module.exports = __webpack_public_path__ + "static/media/ic_black_right_arrow.1442ff55.svg";